import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'

const cx = (...c) => c.filter(Boolean).join(' ')

function Specs({ specs }) {
  return (
    renderSpecsList(specs, true)
  )
}

const renderSpecsList = (specs, horizontal) => {
  if (!specs) return null

  return (
    <div className={cx(styles.specsWrapper, horizontal && styles.specsWrapperHorizontal)}>
      { specs.map((spec, index) => (
        <>
          <div className={cx(styles.line, styles.lineShow)}/>
          { renderSingleSpec(spec.title, spec.subtitle, spec.icon, false)}
          <div className={cx(styles.line, index === specs.length - 1 && styles.lineShow)}/>
        </>
      ))}
    </div>
  )
}

export const renderSingleSpec = (title, subtitle, icon, fullWidth) => {
  return (
    <div className={cx(styles.spec, fullWidth && styles.specFullWidth)}>
      {/* eslint-disable-next-line local-rules/img-requires-dimensions -- faithful port of the former (empty) styled.img Icon: no reserved box existed pre-migration; sizing is intrinsic/CSS-driven, adding fabricated dimensions would alter layout (#89) */}
      {icon && <img src={icon?.src}/>}{/* task #67: styled img src from descriptor */}
      <div className={styles.specTitle}>
        <SimpleBlockContent blocks={title} noSpace/>
      </div>
      <div className={styles.specSubtitle}>
        <SimpleBlockContent blocks={subtitle} noSpace/>
      </div>
    </div>
  )
}

export default Specs
